import { Box, SxProps, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useIsDesktop } from 'Hooks';
import { PurpleTriangle } from 'Images';

interface INewItemBadge {
  boxStyles?: SxProps;
}

export const NewItemBadge = ({ boxStyles }: INewItemBadge) => {
  const isDesktop = useIsDesktop();

  return (
    <Box
      sx={{
        position: 'absolute',
        width: isDesktop ? '80px' : '64px',
        height: '27px',
        ...boxStyles,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          position: 'absolute',
          width: isDesktop ? '80px' : '64px',
          height: '27px',
          padding: '6xp 12px',
          top: '0',
          right: '0',
          zIndex: '2',
          backgroundColor: 'purple2.shade_400',
          borderRadius: '16px 0px 8px 0px',
        }}
      >
        <Typography
          tabIndex={0}
          aria-live='assertive'
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            color: '#fff',
          }}
        >
          {Dictionary[DICTIONARY.General].new}
        </Typography>
      </Box>
      <Box
        component='img'
        sx={{
          position: 'absolute',
          width: '16px',
          height: '13px',
          left: '0px',
          top: '27px',
        }}
        src={PurpleTriangle}
        alt={Dictionary[DICTIONARY.General].new}
      />
    </Box>
  );
};
